import { publicPath } from "Constants/constants";

export function getRootUri(): string {
  if (window.env && window.env.ROOT_BREADCRUMB) {
    return window.env.ROOT_BREADCRUMB;
  }
  return `/${publicPath}`;
}
